import { DesignModules, MenuSections } from 'components/email-layout/constants'
import { HeaderLogoWidth } from 'components/email-layout/edit-sections/headerandlogo'
import { MenuItem, TabMenu } from 'components/tab-menu/component'
import { RasaContext } from 'context'
import React from 'react'
import { connect } from 'react-redux'
import * as Router from 'router'
import * as Modals from 'shared/modals'
import '../../../email-layout/styles.scss'
import { FooterEdit } from 'components/email-layout/edit-sections/footer'
import { Loading } from 'components/loading'
import { Dataset } from 'generic/dataset'
import { BaseClientEntity } from 'generic/baseClientEntity'
interface TemplateCodesEditState extends Modals.ModalComponentState {
  code?: string,
  codeCreated?: boolean,
  configs: any,
  emailLayoutId: string,
  emailLayout: any,
  isDirty: boolean
  isLoading: boolean,
  selectedTab?: string,
}
enum ConfigMenus {
  HEADER = 'header',
  FOOTER = 'footer',
}

interface TemplateCodesEditProps extends Modals.ModalComponentProps {
  onLayoutChange: any,
  communityId: string,
  emailLayoutId: string,
  emailLayout: any,
}
export class TemplateCodesEditModal extends Modals.GenericModalComponent<TemplateCodesEditProps, TemplateCodesEditState> {
  public static key: string = 'templateCodesEdit'
  public static contextType = RasaContext

  constructor(props: TemplateCodesEditProps) {
    super(props, TemplateCodesEditModal.key)
    this.state = {
      code: '',
      codeCreated: false,
      configs: {},
      emailLayoutId: '',
      emailLayout: {},
      isDirty: false,
      isLoading: true,
      selectedTab: ConfigMenus.HEADER,
    }
  }
  
  public componentDidUpdate(prevProps: any, prevState: any) {
    const data = this.props.data[this.key].data
    if (data.community_partner_code !== prevProps.data[this.key].data.community_partner_code) {
      this.setState({
        isLoading: true,
      })
    return new Dataset().loadCommunityDataset('communityConfigurationsByPartnerCode',
      this.props.communityId,
      [{param: 'communityPartnerCodeVal', value: encodeURIComponent(data.community_partner_code)}])
        .then((cpConfigs) => {
          if (cpConfigs[0].length > 0) {
            const objConfig = cpConfigs[0].reduce((acc, curr) => ({...acc, [curr.key]: curr.value}), {})
            this.setState({
              emailLayout: objConfig,
              isLoading: false,
            })
          } else {
            this.setState({
              emailLayout: {},
              isLoading: false,
            })
          }
        })
    }
  }
  
  protected renderChildren(data: any) {
    return this.state.isLoading ? <Loading size='16' /> : <div>
      <div>
        <TabMenu menus={this.configMenus()}
          selectedItemKey={this.state.selectedTab}
          onSelect={(item: MenuItem) => {
            this.setState({
              selectedTab: item.key,
            })
          }}/>
      </div>
      {this.state.selectedTab === ConfigMenus.HEADER ?
        <HeaderLogoWidth data={this.state.emailLayout}
          name={MenuSections.headerAndLogo}
          designModules={[DesignModules.headerLogo]}
          onChange={(field: string, value: string) => this.updateConfig(field, value)} />
      :
      <FooterEdit data={this.state.emailLayout}
        modals={this.props.data}
        openModal={this.props.openModal}
        closeModal={this.props.closeModal}
        name={MenuSections.footer}
        designModules={[DesignModules.footerLogo]}
        onChange={(field: string, value: string) => this.updateConfig(field, value)} />}
    </div>
  }
  private updateConfig = (field, value) => {
    this.setState({
      configs: {
        ...this.state.configs,
        [field]: value
      },
      isDirty: true,
      emailLayout: {
        ...this.state.emailLayout,
        [field]: value,
      }
    })
    // this.props.onLayoutChange(field, value)
  }
  private configMenus = (): MenuItem[] => {
    const menus = [
      {
        name: 'Header',
        key: ConfigMenus.HEADER,
        component: null,
      },
      {
        name: 'Footer',
        key: ConfigMenus.FOOTER,
        component: null,
      },
    ]
    return menus
  }

  protected getSaveText(): string {
    return 'Save'
  }

  protected saveDisabled(): boolean {
    return !this.state.isDirty
  }

  protected onModalClose(data: any) {
    this.setState({
      selectedTab: ConfigMenus.HEADER,
    })
    this.props.closeModal(this.key)
  }

  protected doSave(data: any) {
    return this.context.entityMetadata.getEntityObject('email_layout', this.props.communityId, this.props.emailLayoutId)
    .then((emailLayoutEntityObject: BaseClientEntity) => {
      Object.keys(this.state.configs).forEach((key) => {
        const value = this.state.configs[key]
        emailLayoutEntityObject.data[key] = value
      })
      emailLayoutEntityObject.data.community_partner_code = data.community_partner_code
      emailLayoutEntityObject.save()
    }).catch()
  }
}

export const EditTemplateCodesModal = connect(
  null,
  {
    push: Router.push,
  },
)(TemplateCodesEditModal)
